<div class="display-flex flex-align-center full-height conversion-path-container text-ellipsis" *ngIf="conversionPath; else noData">
  <app-path [path]="path" *ngFor="let path of conversionPath"></app-path>
</div>
<ng-template #noData>-</ng-template>
